'use strict';

let $body = $('body'),
    $window = $(window),
    isMobileDevice = Modernizr.mq('(max-width: 1024px)');

import '../../_assets/abbott/js/_modernizr';

import mCustomScrollbar from 'mCustomScrollbar';

import { debounce } from '../../_assets/abbott/js/_helper';

export default class FormDropdown {
    constructor() {
        $.fn.materialize = function () {
            return this.each(function () {
                var $this = $(this),
                    $wrapperNative = $('<div class = "select-wrapper"/>'),
                    markup = '',
                    firstOption = $this.find('option:first-child').text(),
                    placeholder =  firstOption.replace('Select a', '');                  

                $this
                    .wrap($wrapperNative)
                    .before('<span class="placeholder">' + placeholder + '</span>')
                    .on('change blur', function () {
                        var $this = $(this),
                            $parent = $this.parent(),
                            $error = $parent.find('.error');

                        if ($this.val() == '' && $this.prop('required')) {


                            if($this.is('#NewAdminRegion') && $('#NewAdminSalesRepId').val() == ''){
                                $parent.removeClass('incomplete').addClass('complete');

                                $error.slideUp({
                                    duration: 500,
                                    easing: 'easeOutExpo',
                                    queue: false
                                });

                                return false;
                            }

                            if(!$this.prop('required')){

                                $parent.removeClass('incomplete').addClass('complete');

                                return false;

                            }

                            $parent.addClass('incomplete').removeClass('complete');

                            $error.slideDown({
                                duration: 500,
                                easing: 'easeOutExpo',
                                queue: false
                            });
                        } else {

                            $parent.removeClass('incomplete').addClass('complete');

                            $error.slideUp({
                                duration: 500,
                                easing: 'easeOutExpo',
                                queue: false
                            });
                        }
                    });

                if ($this.data('error') !== undefined && $this.data('error') !== '') {
                    $this.after('<span class="error">' + $this.data('error') + '</span>');
                }

                if ($this.val() != '') {
                    $this.parent().removeClass('incomplete').addClass('complete');
                }
            });
        };

        $('.native').materialize();
    }
}
